// src/components/Layout.js  
import React from 'react';  
import { Link } from 'react-router-dom';  
import logo from '../pages/images/agrist_ai.png'; // ロゴのパスを正しく指定してください  

const Header = () => {  
  return (  
    <header style={{ position: 'absolute', top: 0, right: 0, padding: '10px' }}>  
      <Link to="/">  
        <img src={logo} alt="Company Logo" style={{ height: '20px' }} />  
      </Link>  
    </header>  
  );  
};  
  
export default Header;  
